const twoFactorAuthDE = {
    "view": {
        "title": "Zwei-Faktor-Authentifizierung",
        "form": {
            "label": {
                "currentMethod": "Aktuelle Zwei-Faktor-Methode",
                "authenticatorSetupTitle": "Richten Sie Ihre Authenticator-App ein",
                "scanInstructions": "Scannen Sie den unten stehenden QR-Code mit einer beliebigen TOTP-Authenticator-App (wie Authy, Google Authenticator, Microsoft Authenticator usw.).",
                "qrCodeAlt": "QR-Code für Authenticator-Einrichtung",
                "step1": "Öffnen Sie Ihre Authenticator-App.",
                "step2": "Wählen Sie die Option, ein neues Konto hinzuzufügen.",
                "step3": "Wählen Sie in der App die Option \"Einen QR-Code scannen\".",
                "step4": "Richten Sie die Kamera Ihres Telefons auf den obigen QR-Code.",
                "step5": "Sobald gescannt, beginnt der Authenticator mit der Generierung eines 6-stelligen OTP-Codes, der alle 30 Sekunden aktualisiert wird. Dieser OTP-Code kann verwendet werden, um den Anmeldevorgang abzuschließen.",
                "appLinks": "Hier sind die Links zu einigen gängigen Authenticator-Apps:",
                "appLinksAuthy": "Authy",
                "appLinksGoogle": "Google Authenticator",
                "appLinksMicrosoft": "Microsoft Authenticator",
                "googlePlay": "Google Play Store",
                "appStore": "Apple App Store",
                "loadingQrCode": "QR-Code wird geladen...",
                "emailSetupTitle": "Zwei-Faktor-Authentifizierung per E-Mail",
                "emailDescription": "Sie erhalten ein Einmalpasswort (OTP) an Ihre registrierte E-Mail-Adresse, das zur Vervollständigung des Anmeldevorgangs verwendet werden kann. Stellen Sie sicher, dass Sie Ihr E-Mail-Postfach oder den Spam-Ordner auf das OTP überprüfen, wenn Sie sich anmelden."
            },
            "help_text": {
                "currentMethod": "E-Mail ist derzeit als Standardmethode für die Zwei-Faktor-Authentifizierung festgelegt. Wir empfehlen jedoch die Verwendung der Authenticator-Methode für erhöhte Sicherheit."
            },
            "option": {
                "2faMethod": {
                    "selectMethod": "2FA-Methode auswählen",
                    "email": "E-Mail",
                    "auth": "Authenticator"
                }
            },
            "button": {
                "save": "Speichern",
                "saving": "Speichern..."
            }
        },
        "backupCodes": {
            "title": "Backup-Codes",
            "view": {
                "button": {
                    "generate": "Backup-Codes generieren",
                    "download": "Backup-Codes herunterladen"
                },
                "modal": {
                    "header": "Ihre Backup-Codes",
                    "body": {
                        "noCodes": "Keine Backup-Codes verfügbar"
                    }
                }
            }
        }
    }
};

export default twoFactorAuthDE;